import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from 'recharts'

interface SentimentChartProps {
  sentiment: {
    positive: number
    neutral: number
    negative: number
  }
}

const COLORS = {
  positive: '#22c55e',
  neutral: '#6b7280',
  negative: '#ef4444',
}

export function SentimentChart({ sentiment }: SentimentChartProps) {
  const data = [
    { name: '긍정', value: sentiment.positive },
    { name: '중립', value: sentiment.neutral },
    { name: '부정', value: sentiment.negative },
  ]

  return (
    <ResponsiveContainer width="100%" height={200}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={40}
          outerRadius={80}
          paddingAngle={5}
          dataKey="value"
        >
          {data.map((entry) => (
            <Cell
              key={`cell-${entry.name}`}
              fill={COLORS[entry.name === '긍정' ? 'positive' : entry.name === '중립' ? 'neutral' : 'negative']}
            />
          ))}
        </Pie>
        <Tooltip
          formatter={(value: number) => `${(value * 100).toFixed(1)}%`}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  )
}
